import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import {FeaturesComponent} from "../../features/features.component";

@Injectable()
export class DashboardGuard {
  constructor(
    private router: Router,
    private location: PlatformLocation
  ) { }

  canDeactivate(
    component: FeaturesComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {

      this.location.onPopState((e: any) => {
        if(this.router.url.startsWith('/')){
          this.location.forward();
        };
    });
    return true;

  }
}
